import { render, staticRenderFns } from "./DigitalZoom.vue?vue&type=template&id=5fbfe56e&scoped=true"
import script from "./DigitalZoom.vue?vue&type=script&lang=js"
export * from "./DigitalZoom.vue?vue&type=script&lang=js"
import style0 from "./DigitalZoom.vue?vue&type=style&index=0&id=5fbfe56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfe56e",
  null
  
)

export default component.exports